import React, { useEffect, useRef, useState } from 'react'
import { useStore } from '../../store/Store'
import { apiFace } from '../../host/Host'
import Loader from '../Loader'
import CaptureScreenshot from './CaptureScreenshot'
import { useTranslation } from 'react-i18next'
import { Carousel } from 'react-bootstrap'

const DETECTION_INTERVAL_MS = 2500
const VIDEO_CONSTRAINTS = { audio: false, video: { facingMode: 'user', width: { ideal: 640, max: 640 }, height: { ideal: 480, max: 480 } } }
const noFaceText = {
  uz: "Kamera yuzingizni ko'rmayapti<br/><span>Kamerada yuzingiz ko'rinib turadigan holatda o'tirishingizni so'raymiz</span>",
  ru: "Камера не видит ваше лицо<br/><span>Мы просим вас сидеть так, чтобы ваше лицо было видно в камере</span>",
  krill: "Камера юзингизни кўрмаяпти<br/><span>Камерада юзингиз кўриниб турадиган ҳолда ўтиришингизни сўраймиз</span>",
}
const unrecognizedText = {
  uz: "Kamera sizni tanimayapti<br/><span>Kamerada yuzingiz ko'rinib turadigan holatda o'tirishingizni so'raymiz</span>",
  ru: "Камера не распознает вас<br/><span>Мы просим вас сесть так, чтобы ваше лицо было видно камере</span>",
  krill: "Камера сизни танимаяпти<br/><span>Камерада юзингиз кўриниб турадиган ҳолда ўтиришингизни сўраймиз</span>",
}

export default function FaceDetection({ t_id, finishTestBool, faceapi, bol, setbol, images, checktime, setchecktime, time }) {
  const { t } = useTranslation()
  const user = useStore(state => state.user)
  const bigloader = useStore(state => state.bigloader)
  const setbigloader = useStore(state => state.setbigloader)
  const setdetectionsImage = useStore(state => state.setdetectionsImage)
  const videoRef = useRef(null)
  const imageRef = useRef(null)
  const detectorTimerRef = useRef(null)
  const streamRef = useRef(null)
  const matcherRef = useRef(null)
  const detectionInFlightRef = useRef(false)
  const isMountedRef = useRef(true)
  const [capture, setcapture] = useState(false)
  const [errorText, seterrorText] = useState(null)
  const [referenceReady, setreferenceReady] = useState(false)
  const faceDetectionEnabled = user?.faceDetection === true

  const safeText = value => !value ? '' : String(value).replace(/<[^>]*>/g, ' ')
  const multipleFacesText = count => ({
    uz: `Kamerada ${count} ta inson ko'rinyapti<br/><span>O'zingizdan boshqa insonlar kompyuterdan uzoqlashsin</span>`,
    ru: `На камере видны ${count} человека<br/><span>Не подпускайте к компьютеру других людей, кроме вас</span>`,
    krill: `Камерада ${count} та инсон кўринаяпти<br/><span>Ўзингиздан бошқа инсонлар компьютердан узоқлашсин</span>`,
  })

  useEffect(() => {
    return () => {
      isMountedRef.current = false
      if (detectorTimerRef.current) clearInterval(detectorTimerRef.current)
      streamRef.current?.getTracks().forEach(track => track.stop())
    }
  }, [])

  // Exactly one low-resolution stream is opened and always released on exit.
  useEffect(() => {
    if (!user || !faceapi || streamRef.current) return
    let cancelled = false
    navigator.mediaDevices.getUserMedia(VIDEO_CONSTRAINTS).then(stream => {
      if (cancelled || !isMountedRef.current) return stream.getTracks().forEach(track => track.stop())
      streamRef.current = stream
      if (videoRef.current) videoRef.current.srcObject = stream
    }).catch(() => {
      if (!isMountedRef.current) return
      seterrorText(noFaceText)
      setchecktime(true)
      setbigloader(false)
    })
    return () => { cancelled = true }
  }, [faceapi, setbigloader, setchecktime, user])

  // The reference descriptor and FaceMatcher are built once, rather than on every frame.
  useEffect(() => {
    if (!user || !faceapi) return
    if (!faceDetectionEnabled) {
      matcherRef.current = null
      setreferenceReady(true)
      setbigloader(false)
      return
    }
    let cancelled = false
    const createMatcher = async () => {
      const image = imageRef.current
      if (!image) return
      if (!image.complete) await new Promise(resolve => { image.onload = resolve; image.onerror = resolve })
      if (cancelled || !image.naturalWidth) return
      const canvas = document.createElement('canvas')
      const scale = Math.min(1, 320 / image.naturalWidth)
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale))
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale))
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
      const descriptor = await faceapi.detectSingleFace(canvas, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceDescriptor()
      if (cancelled || !isMountedRef.current) return
      if (!descriptor) {
        seterrorText(unrecognizedText)
        setchecktime(true)
        setbigloader(false)
        return
      }
      matcherRef.current = new faceapi.FaceMatcher([new faceapi.LabeledFaceDescriptors('candidate', [descriptor.descriptor])])
      setdetectionsImage(descriptor)
      setreferenceReady(true)
      setbigloader(false)
    }
    setreferenceReady(false)
    createMatcher().catch(() => {
      if (!isMountedRef.current) return
      seterrorText(unrecognizedText)
      setchecktime(true)
      setbigloader(false)
    })
    return () => { cancelled = true }
  }, [faceDetectionEnabled, faceapi, setbigloader, setchecktime, setdetectionsImage, user])

  useEffect(() => {
    if (!faceDetectionEnabled) {
      if (bol) { setbol(false); setcapture(true) }
      return
    }
    if (!referenceReady || !matcherRef.current || !videoRef.current || finishTestBool) return
    const detect = async () => {
      if (detectionInFlightRef.current || !videoRef.current || videoRef.current.readyState < 2) return
      detectionInFlightRef.current = true
      try {
        const detections = await faceapi.detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceDescriptors()
        if (!isMountedRef.current) return
        if (detections.length === 0) { seterrorText(noFaceText); setchecktime(true); return }
        if (detections.length > 1) { seterrorText(multipleFacesText(detections.length)); setchecktime(true); return }
        if (matcherRef.current.findBestMatch(detections[0].descriptor).label === 'unknown') { seterrorText(unrecognizedText); setchecktime(true); return }
        setchecktime(false)
        if (bol) { setbol(false); setcapture(true) }
      } catch {
        if (isMountedRef.current) { seterrorText(noFaceText); setchecktime(true) }
      } finally { detectionInFlightRef.current = false }
    }
    detect()
    detectorTimerRef.current = setInterval(detect, DETECTION_INTERVAL_MS)
    return () => { if (detectorTimerRef.current) clearInterval(detectorTimerRef.current); detectorTimerRef.current = null }
  }, [bol, faceDetectionEnabled, faceapi, finishTestBool, referenceReady, setbol, setchecktime])

  return <div className='faceBox'>
    {capture && <CaptureScreenshot t_id={t_id} video={videoRef.current} resetCapture={() => setcapture(false)} />}
    <video className='videoTag' crossOrigin='anonymous' style={{ height: '100%', width: 'auto', transform: 'rotateY(180deg)' }} ref={videoRef} autoPlay playsInline />
    {images !== null && images.length !== 0 && <div className='images_finish'><Carousel>{images.map(item => <Carousel.Item key={item.id} interval={3000}><img className='d-block w-100' src={`data:image/png;base64,${item.imageBase64}`} alt='Test screenshot' /></Carousel.Item>)}</Carousel></div>}
    {bigloader && <Loader />}
    <div className={`tooltip_face ${checktime ? 'tooltip_face_active' : ''}`}><div><h1><span>{parseInt(parseInt(time / 60) / 10)}</span><span>{parseInt(parseInt(time / 60) % 10)}</span><span>:</span><span>{parseInt(parseInt(time % 60) / 10)}</span><span>{parseInt(parseInt(time % 60) % 10)}</span></h1></div><p>{safeText(errorText?.[t('lang')])}</p></div>
    {user && <img ref={imageRef} crossOrigin='anonymous' style={{ display: 'none' }} src={apiFace + user.avatar} alt='' />}
  </div>
}
